import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'react-addons-update';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { stateCodes } from './user-form-utils';
import CargomaticInput from '../../v2/input';
import CargomaticSelect from '../../v2/select';
class AddressForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            address: {
                name: props.address.name || '',
                city: props.address.city || '',
                state: props.address.state || '',
                street: props.address.street || '',
                street2: props.address.street2 || '',
                zipcode: props.address.zipcode || '',
            },
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            address: {
                name: nextProps.address.name || '',
                city: nextProps.address.city || '',
                state: nextProps.address.state || '',
                street: nextProps.address.street || '',
                street2: nextProps.address.street2 || '',
                zipcode: nextProps.address.zipcode || '',
            },
        });
    }
    handleChange(value, addressSubName) {
        this.setState((state) => {
            const updatedAddress = update(state.address, {
                $merge: { [addressSubName]: value },
            });
            const newState = update(state, {
                $merge: { address: updatedAddress },
            });
            return newState;
        }, () => this.props.onChange(this.state.address));
    }
    render() {
        const { t } = this.props;
        const user_address_state = stateCodes.find((code) => code.abbreviation === this.state.address.state ||
            code.name === this.state.address.state) || {};
        return (React.createElement("div", { className: "grid grid-cols-6 gap-4" },
            React.createElement(CargomaticInput, { className: "lg:col-span-full", label: t('NAME'), value: this.state.address.name || '', disabled: this.props.disabled, onChange: (value) => this.handleChange(value, 'name') }),
            React.createElement(CargomaticInput, { className: "lg:col-span-full", label: t('STREET_ADDRESS_1'), value: this.state.address.street || '', disabled: this.props.disabled, onChange: (value) => this.handleChange(value, 'street') }),
            this.state.street2 && (React.createElement(CargomaticInput, { className: "lg:col-span-full", label: t('STREET_ADDRESS_2'), value: this.state.address.street2 || '', disabled: this.props.disabled, onChange: (value) => this.handleChange(value, 'street2') })),
            React.createElement(CargomaticInput, { className: "col-span-full", label: titleize(t('CITY')), value: this.state.address.city || '', disabled: this.props.disabled, onChange: (value) => this.handleChange(value, 'city') }),
            React.createElement(CargomaticSelect, { className: "col-span-2", items: stateCodes, label: titleize(t('STATE')), value: user_address_state.abbreviation, disabled: this.props.disabled, onSelect: (item) => this.handleChange(item.abbreviation, 'state'), valueKey: "abbreviation", textKey: "name" }),
            React.createElement(CargomaticInput, { className: "col-span-3", label: t('ZIP_CODE'), value: this.state.address.zipcode || '', disabled: this.props.disabled, pattern: "[0-9]{5}", onChange: (value) => this.handleChange(value, 'zipcode') })));
    }
}
AddressForm.propTypes = {
    disabled: PropTypes.bool,
};
AddressForm.defaultProps = {
    disabled: false,
};
export default withTranslation()(AddressForm);
